export const DEMO_TITLES: {[key: string]: string} = {
  resnet18: "ResNet18 Fine tuned",
};

export const DEMO_DESCRIPTIONS: {[key: string]: string} = {
  resnet18: "ResNet18 Fine tuned and used in a browser.",
};
